import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function SettingsSolid({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-4.5 -4 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g fill="none" fillRule="evenodd">
        <path
          className={theme.fill}
          d="M15.3711851 21.4387333c-2.9819362 0-5.40785106-2.452-5.40785106-5.466 0-3.014 2.42591486-5.4653333 5.40785106-5.4653333s5.4071915 2.4513333 5.4071915 5.4653333c0 3.014-2.4252553 5.466-5.4071915 5.466zM26.8504191 17.5034c.062-.5.1081703-.9993333.1081703-1.5306667 0-.5306666-.0461703-1.0306666-.1081703-1.53l3.2602766-2.5766666c.2935107-.2346667.3706809-.656.1853405-.9993334L27.2052702 5.4634c-.1846808-.344-.6021915-.46866667-.9418723-.344l-3.8466383 1.562c-.8040213-.62466667-1.669383-1.14-2.6112553-1.53066667l-.5876809-4.13866666C19.1716532.6374 18.8478021.35673333 18.4612915.35673333h-6.1808724c-.385851 0-.7103617.28066667-.7565319.65533334l-.5876808 4.13866666C9.99433404 5.5414 9.12897234 6.07206667 8.32561064 6.6814l-3.84729787-1.562c-.35551064-.14-.75653192 0-.94187234.344L.44567447 10.8667333c-.20117021.3433334-.10817022.7646667.18534042.9993334l3.2602766 2.5766666c-.062.4993334-.10817021 1.0146667-.10817021 1.53 0 .5153334.04617021 1.0306667.10817021 1.5306667l-3.2602766 2.5766667c-.29351064.234-.37068085.656-.18534042.9993333l3.09076596 5.4033333c.18534042.344.60219148.4686667.94187234.344l3.84729787-1.562c.8033617.6246667 1.6687234 1.14 2.61059576 1.5306667l.5876808 4.138c.0461702.3746667.3706809.656.7565319.656h6.1808724c.3865106 0 .7103617-.2813333.7565319-.656l.5876809-4.138c.9418723-.3906667 1.807234-.922 2.6112553-1.5306667l3.8466383 1.562c.3555106.14.7571915 0 .9418723-.344l3.090766-5.4033333c.1853404-.3433333.1081702-.7653333-.1853405-.9993333L26.8504191 17.5034z"
        />
      </g>
    </svg>
  )
}

SettingsSolid.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
